// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__3e9Af","boxTitle":"Qualiphy_boxTitle__2tlyY","box":"Qualiphy_box__2oZLd","toggleWrap":"Qualiphy_toggleWrap__GbYZO"};